export default __webpack_public_path__ + "static/media/2.92c99b2a.svg";